import "core-js/modules/es6.array.map";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.array.is-array";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/es6.function.name";
import _isString from "lodash/isString";
import _isFinite from "lodash/isFinite";
import _get from "lodash/get";
import { formatCurrency, formatPercent } from '@nerdwallet/nw-client-lib/num';
import validationResult from './result';

var getValue = function getValue(data, _ref) {
  var name = _ref.name;
  return _get(data, name);
};

function validateEnum(value, whitelist) {
  var valid = whitelist.indexOf(value) !== -1;
  return validationResult({
    valid: valid,
    message: 'Please select an option'
  });
}

export function formatNumber(value, input) {
  var formatType = _get(input, 'viewConfig.formatType');

  switch (formatType) {
    case 'currency':
      return formatCurrency(value);

    case 'percentage':
      return formatPercent(value);

    default:
      return value;
  }
}
export function validateBoolean(data, input) {
  var value = getValue(data, input);
  return validateEnum(value, [true, false]);
}
export function validateNumber(data, input) {
  var value = getValue(data, input);

  if (!_isFinite(value)) {
    return validationResult({
      valid: false,
      message: 'This field is required'
    });
  }

  var maximum = input.maximum,
      minimum = input.minimum;

  if (value < minimum) {
    return validationResult({
      valid: false,
      message: "Value must be greater than ".concat(formatNumber(minimum, input))
    });
  }

  if (value > maximum) {
    return validationResult({
      valid: false,
      message: "Value must be less than ".concat(formatNumber(maximum, input))
    });
  }

  return validationResult({
    valid: true
  });
}
export function validateString(data, input) {
  var value = getValue(data, input);

  if (!_isString(value) || value === '') {
    return validationResult({
      valid: false,
      message: 'Please enter a value'
    });
  }

  if (_isFinite(input.maxLength) && value.length > input.maxLength) {
    return validationResult({
      valid: false,
      message: "Value must be less than ".concat(input.maxLength, " characters") // TODO format number?

    });
  }

  if (_isFinite(input.minLength) && value.length < input.minLength) {
    return validationResult({
      valid: false,
      message: "Value must be more than ".concat(input.minLength, " characters") // TODO format number?

    });
  }

  return validationResult({
    valid: true
  });
}
export function validateArray(data, input) {
  var values = _get(data, input.name, []);

  if (Array.isArray(values) && values.length === 0 && !input.required) {
    return validationResult({
      valid: true
    });
  }

  if (Array.isArray(values) && values.length) {
    var invalidValues = values.map(function (value) {
      return {
        value: value,
        valid: validateEnum(value, input.whitelist).valid
      };
    }).filter(function (_ref2) {
      var valid = _ref2.valid;
      return !valid;
    });
    return validationResult({
      valid: invalidValues.length === 0,
      message: "Invalid value ".concat(invalidValues.map(function (_ref3) {
        var value = _ref3.value;
        return value;
      }).join(', '))
    });
  }

  return validationResult({
    valid: false,
    message: 'Please select an option'
  });
}
export function validateWhitelist(data, input) {
  return validateEnum(getValue(data, input), input.whitelist);
}
export var validateType = {
  array: validateArray,
  "boolean": validateBoolean,
  "float": validateNumber,
  integer: validateNumber,
  string: validateString
};